















































































































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import TextEditor from '@/components/TextEditor/TextEditor.vue'
import {
  EEditMode,
  ETinyFileType,
  ITinyEditorData,
  Mentionable,
  OptionGroupViewer,
  TopicDetails
} from '@/models'
import PreviewText from '@/helpers/PreviewText'
import { checkScript } from '@/validations/validation'
//@ts-ignore
import _, { DebouncedFunc } from 'lodash'
import GroupMemberService from '@/services/GroupMemberService'
import {
  allItemMention,
  allMentionCheckKeyword,
  loadingItemMention,
  mentionRegex,
  MENTION_VALUE,
  handleSelectSuggestion,
  getCaretTextBefore,
} from '@/helpers/Mentions'
//@ts-ignore
import At from 'vue-at'
import {
  applyRange,
  ensureRange,
  getRange,
  insertMention,
  getPrecedingRange,
  getAtAndIndex
} from '@/helpers/Common'
import InputSearchMention from '@/components/InputSearchMention.vue'
import SearchMentionBox from '@/components/SearchMentionBox.vue'
import CheckDevice from '@/helpers/CheckDevice'

if (At.methods?.insertHtml) {
  At.methods.insertHtml = function(html: any, r: Range) {
    r.deleteContents()

    // Clean up the leftover trigger text (like "@")
    if (r.startContainer.nodeType === Node.TEXT_NODE) {
      const node = r.startContainer as Text
      if (!node.nodeValue || /^@/.test(node.nodeValue)) {
        node.parentNode?.removeChild(node)
      }
    }

    // Create the mention wrapper
    const newElement = document.createElement('span')
    newElement.setAttribute('data-at-embedded', '')
    newElement.setAttribute('contenteditable', 'false')

    // Add spaces before and after mention (same as original vue-at)
    newElement.appendChild(document.createTextNode(' '))
    newElement.appendChild(this.htmlToElement(html))
    newElement.appendChild(document.createTextNode(' '))

    // Insert mention into the range
    r.insertNode(newElement)

    // Add an empty text node separator after the mention
    // → prevents backspace from deleting multiple mentions at once
    const separator = document.createTextNode(' ')
    if (newElement.parentNode) {
      newElement.parentNode.insertBefore(separator, newElement.nextSibling)
    }

    // Place caret after the separator
    r.setStartAfter(separator)
    r.collapse(true)

    applyRange(r)
  }
}

if (At.methods?.handleDelete) {
  At.methods.handleDelete = function(e: any) {
    const range = getPrecedingRange()
    if (range) {
      if (this.customsEmbedded && range.endOffset >= 1) {
        let a: any =
          range.endContainer.childNodes[range.endOffset] ||
          range.endContainer.childNodes[range.endOffset - 1]
        if (!a || (a.nodeType === Node.TEXT_NODE && !/^\s?$/.test(a.data))) {
          return
        } else if (a.nodeType === Node.TEXT_NODE) {
          if (a.previousSibling) a = a.previousSibling
        } else {
          if (a.previousElementSibling) a = a.previousElementSibling
        }
        let ch: any[] = [].slice.call(a.childNodes)
        ch = [].reverse.call(ch)
        ch.unshift(a)
        let last
        ;[].some.call(ch, (c: any) => {
          if (c.getAttribute && c.getAttribute('data-at-embedded') != null) {
            last = c
            return true
          }
        })
        if (last) {
          e.preventDefault()
          e.stopPropagation()
          const r = getRange()
          if (r) {
            r.setStartBefore(last)
            r.deleteContents()
            applyRange(r)
            this.handleInput()
          }

          const editable = this.$el.querySelector(
            '[contenteditable="true"]'
          ) as HTMLElement

          if (editable) {
            const emptyDivs = editable.querySelectorAll('div')
            emptyDivs.forEach(div => {
              if (!div.textContent?.trim() && div.children.length === 0) {
                div.innerHTML = '<br>'
                // handle on mobile
                const isMobile = CheckDevice.isMobile()
                if (isMobile) {
                  editable.focus()
                }

                const range = document.createRange()
                range.setStart(div, 0) // caret ngay trong div
                range.collapse(true)

                const sel = window.getSelection()
                sel?.removeAllRanges()
                sel?.addRange(range)
                this.handleInput()
              }
            })
          }
        }
        return
      }

      const { atItems, members, suffix, deleteMatch, itemName } = this
      const text = range.toString()
      const { at, index } = getAtAndIndex(text, atItems)

      if (index > -1) {
        const chunk = text.slice(index + at.length)
        const has = members.some((v: any) => {
          const name = itemName(v)
          return deleteMatch(name, chunk, suffix)
        })
        if (has) {
          e.preventDefault()
          e.stopPropagation()
          const r = getRange()
          if (r) {
            r.setStart(r.endContainer, index)
            r.deleteContents()
            applyRange(r)
            this.handleInput()
          }
        }
      }
    }
  }
}

@Component({
  components: { TextEditor, At, InputSearchMention, SearchMentionBox }
})
export default class TextAreaWithMode extends Vue {
  @Prop({ default: false }) keepOnlyIndentHtml?: boolean
  @Prop({ default: true }) allowMention?: boolean
  @Prop({ default: false }) shouldHandleInitMentionContentEditable?: boolean
  @Prop() title!: string
  @Prop({ default: '' }) titleSuffix?: string
  @Prop({ default: 4 }) private areaRows?: number
  @Prop() defaultValue!: any
  @Prop() private mode?: EEditMode
  @Prop() tinyFileType!: ETinyFileType //important
  @Prop() maxFileSize?: any
  @Prop() textAreaId?: string
  @Prop() topicDetail?: TopicDetails
  eEditMode: any = EEditMode
  selectedMode: EEditMode = EEditMode.TEXT
  tinyEditorData: ITinyEditorData = {
    html: '',
    text: '',
    fileIds: []
  }
  isCommonTopic = !this.$route.params.groupId
  public noAvatar = require('@/assets/images/avatar-default.png')

  // mentions
  suggestionList: any[] = []
  private preventFetchMention = false
  private debouncedFetchMention: DebouncedFunc<(event: any) => void>
  private hasSetInitialCursor = false
  mentionValue: any = MENTION_VALUE
  private failKeyword = ''
  private lastKeyword = ''
  listToSearchMentionWithBox: Mentionable[] = []
  listToSearchMentionWithBoxDefault: Mentionable[] = []
  private savedRange: Range | null = null // use in current mode
  private editorInstance: any
  isLoading: boolean = false

  //validate
  includesScriptTagContent: boolean = false
  // private includesEmoji: boolean = false
  overLengthContent: boolean = false
  // private includesEmojiMess: string = this.$t('common.form.no_emoji', {
  //   name: this.$t('common.form.document')
  // }) as string
  overLengthMess: string = this.$t('common.form.max_length', {
    name: this.$t('common.form.document'),
    length: 20000
  }) as string
  includesScriptTagMess: string = this.$t('common.form.no_script_tag', {
    name: this.$t('common.form.document')
  }) as string

  get atInstance() {
    return this.$refs.at as any
  }

  async created() {
    this.debouncedFetchMention = _.debounce(
      this.handleSuggesionListOutsideEditor,
      500
    )

    if (!this.isCommonTopic && this.allowMention) {
      const result = await this.fetchMentionApi({ keyword: '' })
      this.listToSearchMentionWithBoxDefault = [allItemMention, ...result]
      this.listToSearchMentionWithBox = [
        ...this.listToSearchMentionWithBoxDefault
      ]
    }
  }

  closePanel() {
    if (this.atInstance) {
      this.atInstance.closePanel()
    }
  }

  mounted() {
    window.addEventListener('scroll', () => {
      this.closePanel()
    })

    if (this.atInstance) {
      const editorEl = this.atInstance.$el.querySelector(
        '.mention-contenteditable'
      )
      if (!editorEl) return

      editorEl.addEventListener('input', this.onContentEditableInput)
      editorEl.addEventListener('focusout', this.onContentEditableFocusOut)
      editorEl.addEventListener('focusin', this.onContentEditableFocusIn)
      editorEl.addEventListener('keyup', this.onContentEditableKeyUp)
      editorEl.addEventListener('paste', this.onContentEditablePaste)

      this.$nextTick(() => {
        setTimeout(() => {
          editorEl?.focus()
        }, 50)
      })
    }
  }

  beforeDestroy() {
    window.removeEventListener('scroll', () => {
      this.closePanel()
    })

    if (this.atInstance) {
      const editorEl = this.atInstance.$el.querySelector(
        '.mention-contenteditable'
      )
      if (!editorEl) return

      editorEl.removeEventListener('input', this.onContentEditableInput)
      editorEl.removeEventListener('focusout', this.onContentEditableFocusOut)
      editorEl.removeEventListener('focusin', this.onContentEditableFocusIn)
      editorEl.removeEventListener('keyup', this.onContentEditableKeyUp)
      editorEl.removeEventListener('paste', this.onContentEditablePaste)
    }
  }

  @Watch('selectedMode')
  watchSelectedMode(newMode: EEditMode) {
    this.$emit('updateMode', newMode)

    // sync data between mode
    if (this.selectedMode === EEditMode.HTML) {
      this.tinyEditorData.html = this.tinyEditorData.text
    } else {
      this.tinyEditorData.text = this.tinyEditorData.html
    }
  }

  @Watch('mode')
  watchMode() {
    this.selectedMode = this.mode ? this.mode : EEditMode.TEXT
  }

  @Watch('defaultValue')
  setValueForTextArea() {
    this.tinyEditorData = {
      html: this.defaultValue.html ? this.defaultValue.html : '',
      text: this.defaultValue.text ? this.defaultValue.text : '',
      fileIds: this.defaultValue.fileIds ? this.defaultValue.fileIds : []
    }
  }

  @Watch('tinyEditorData.html')
  @Watch('tinyEditorData.text')
  @Watch('inyEditorData.fileIds')
  @Watch('selectedMode')
  handleTextChange() {
    this.$emit('getValue', {
      html: this.tinyEditorData.html,
      text: this.tinyEditorData.text,
      fileIds: this.tinyEditorData.fileIds,
      mode: this.selectedMode
    })
  }

  /**
   * Validation
   *
   * Check content
   */
  @Watch('tinyEditorData.html')
  @Watch('tinyEditorData.text')
  @Watch('selectedMode')
  handleContentError() {
    const temp = document.createElement('div')
    if (this.selectedMode === EEditMode.HTML) {
      temp.innerHTML = this.tinyEditorData.html
    } else {
      temp.innerHTML = this.tinyEditorData.text
    }
    const text = temp.innerText

    this.overLengthContent =
      new Blob([text]).size > 80000 || _.toArray(text).length > 20000

    this.includesScriptTagContent = checkScript(text)
    const valid = [
      // this.includesEmoji,
      this.overLengthContent,
      this.includesScriptTagContent
    ].every(item => !item)
    this.$emit('validContent', valid)
  }

  getEditorData(data: ITinyEditorData) {
    if (this.selectedMode === EEditMode.HTML) {
      this.tinyEditorData.html = data.html
      this.tinyEditorData.text = data.text
      this.tinyEditorData.fileIds = data.fileIds
    }
  }

  /**
   * Handle long text
   */
  handleLongText(text: string) {
    return PreviewText.covertToPreviewText(text ? text : '')
  }

  async fetchMentionApi({
    keyword,
    callback,
    shouldHandleKeyword = true,
    shouldHandleLoading = false
  }: {
    keyword: string
    callback?: (mappingData: any[]) => void
    shouldHandleKeyword?: boolean
    shouldHandleLoading?: boolean
  }) {
    if (shouldHandleLoading) {
      this.isLoading = true
    }

    try {
      const groupId = this.$route.params.groupId
      let params: any = {
        groupId,
        page: 1,
        limit: this.$store.state.setting.setting.setting_display
          .number_item_lists,
        search: keyword,
        mention: true
      }

      if (this.topicDetail?.option_viewer === OptionGroupViewer.AUTHORITY) {
        params.onlyAdmin = true
      } else if (this.topicDetail?.option_viewer === OptionGroupViewer.INDIVIDUAL) {
        params.userIds = this.topicDetail?.selected_members.map(item => item.id)
      }


      const res = await GroupMemberService.getAllMembersByGroupId(params)

      let mappingData = []
      // save last success keyword
      if (shouldHandleKeyword) {
        this.lastKeyword = keyword
      }
      if (res.data.data.length > 0) {
        if (shouldHandleKeyword) {
          this.failKeyword = ''
        }
        mappingData = res.data.data.map((item: any) => ({
          id: item.id,
          name: item.name,
          avatar: item?.user_profile?.avatar_small
        }))
      } else {
        if (shouldHandleKeyword) {
          this.failKeyword = keyword
        }
      }
      callback?.(mappingData)
      return mappingData
    } finally {
      setTimeout(() => {
        this.isLoading = false
      }, 500)
    }
  }

  async handleSuggesionListEditor(keyword: string) {
    const response = await this.fetchMentionApi({
      keyword
    })
    return response
  }

  filterMatch(name: string, chunk: any, at: any) {
    if (name.startsWith('_FAKE_')) return true
    return name.toLowerCase().includes(chunk.toLowerCase())
  }

  async handleSuggesionListOutsideEditor(keyword: string) {
    const isDeleting = keyword.length < this.lastKeyword.length

    if (isDeleting) {
      this.failKeyword = ''
    }

    if (this.failKeyword && keyword.startsWith(this.failKeyword)) {
      return
    }

    if (!this.preventFetchMention) {
      this.suggestionList = [] // clear all value
      this.suggestionList.unshift(loadingItemMention) // start fake loading

      const startTime = Date.now()

      await this.fetchMentionApi({
        keyword,
        callback: response => {
          const elapsed = Date.now() - startTime
          const delay = Math.max(0, 500 - elapsed)

          setTimeout(() => {
            this.suggestionList.shift() // end fake loading

            if (response.length > 0) {
              this.suggestionList = response
            }

            // handle all mention
            if (
              !keyword ||
              allMentionCheckKeyword.includes(keyword.toLowerCase())
            ) {
              this.suggestionList.unshift(allItemMention)
            }
          }, delay)
        }
      })
    }

    if (this.preventFetchMention) {
      this.preventFetchMention = false
    }
  }

  onMention(keyword: string) {
    if (!this.isCommonTopic && this.allowMention) {
      this.suggestionList = []
      this.debouncedFetchMention(keyword)
    }
  }

  onInsertData() {
    this.preventFetchMention = true
    this.$nextTick(() => {
      // allow next input
      setTimeout(() => {
        this.preventFetchMention = false
      }, 500)
    })
  }

  // NWS-1762: テキストモードでは貼り付け時に書式(HTML)を持ち込まず、
  // プレーンテキストのみ挿入する（書式編集モードのエディタには影響しない）
  onContentEditablePaste(e: ClipboardEvent) {
    e.preventDefault()
    const text = e.clipboardData?.getData('text/plain') ?? ''
    if (!text) return
    document.execCommand('insertText', false, text)
  }

  onContentEditableInput() {
    if (!this.isCommonTopic && this.allowMention) {
      const editorEl = this.atInstance.$el.querySelector(
        '.mention-contenteditable'
      )
      const caretText = getCaretTextBefore(editorEl)
      const match = caretText.match(mentionRegex)
      if (match) {
        const query = match[1]
        this.atInstance.$emit('at', query)
      }
    }
  }

  onContentEditableFocusOut() {
    this.failKeyword = ''
    this.savedRange = getRange()
  }

  onContentEditableFocusIn() {
    this.$nextTick(() => {
      if (this.atInstance && !this.isCommonTopic && this.allowMention) {
        const editorEl = this.atInstance.$el.querySelector(
          '.mention-contenteditable'
        )
        if (editorEl) {
          requestAnimationFrame(() => {
            const caretText = getCaretTextBefore(editorEl)
            const match = caretText.match(mentionRegex)
            if (match) {
              this.atInstance.$emit('at', match[1])
            }
          })
        }
      }
    })
  }

  onContentEditableKeyUp(e: any) {
    // handle caret by mark a space on previous line when enter
    if (e.key === 'Enter') {
      const editorEl = this.atInstance.$el.querySelector(
        '.mention-contenteditable'
      )
      const newDiv = editorEl.lastElementChild as HTMLElement
      const prevDiv = newDiv?.previousElementSibling as HTMLElement

      if (prevDiv && prevDiv.tagName === 'DIV') {
        prevDiv.appendChild(document.createTextNode(' '))
      }

      if (prevDiv && prevDiv.tagName === 'SPAN') {
        const textNode = document.createTextNode(' ')
        prevDiv.parentNode?.insertBefore(textNode, prevDiv.nextSibling)
      }
    }
  }

  async handleSearchMention({
    keyword,
    listTarget,
    closeDropdownFn,
    shouldHandleLoading
  }: {
    keyword: string
    listTarget: any[]
    closeDropdownFn?: () => void
    shouldHandleLoading?: boolean
  }) {
    const result = await this.fetchMentionApi({
      keyword,
      shouldHandleKeyword: false,
      shouldHandleLoading
    })

    if (
      result.length > 0 ||
      allMentionCheckKeyword.includes(keyword.toLowerCase()) ||
      !keyword
    ) {
      const newList: Mentionable[] = []

      if (allMentionCheckKeyword.includes(keyword.toLowerCase()) || !keyword) {
        newList.push(allItemMention)
      }

      if (result.length > 0) {
        newList.push(...result)
      }

      listTarget.splice(0, listTarget.length, ...newList)
    }

    if (
      result.length === 0 &&
      !allMentionCheckKeyword.includes(keyword.toLowerCase()) &&
      keyword
    ) {
      closeDropdownFn?.()
      this.onClearListWithDelay(listTarget)
    }
  }

  async onSearchMentionWithBox(keyword: string) {

    await this.handleSearchMention({
      keyword,
      listTarget: this.listToSearchMentionWithBox,
      shouldHandleLoading: true
    })
  }

  onClearListWithDelay(listTarget: Mentionable[]) {
    setTimeout(() => {
      listTarget.splice(0, listTarget.length)
    }, 200)
  }

  getEditorInstance(editor: any) {
    this.editorInstance = editor
  }

  onSelectMention(item: Mentionable) {
    const mentionHtml = `<span class="mention" translate="no" data-id=${item.id} style="color: #007bff; font-weight: bold;">@${item.name}</span>`

    if (this.selectedMode === EEditMode.TEXT) {
      const editorEl = this.atInstance.$el.querySelector(
        '.mention-contenteditable'
      )
      if (editorEl) {
        const range = ensureRange(editorEl, this.savedRange)
        this.savedRange = insertMention(range, mentionHtml)
        this.tinyEditorData.text = editorEl.innerHTML
      }
    } else {
      handleSelectSuggestion({
        suggestion: item,
        editorInstance: this.editorInstance,
        insertFromOutside: true
      })
    }

    const searchToMentionBoxRef = this.$refs.searchToMentionBoxRef as any
    if (searchToMentionBoxRef) {
      searchToMentionBoxRef.closeDropdown()
    }
  }
}
